<template>
  <base-modal overlay-class="lantern_modal">
    <div class="content">
      <template v-if="successful">
        <h1>{{ getTranslations.modal_post_game_lantern_success_title }}</h1>

        <p>{{ getTranslations.modal_post_game_lantern_success_subtitle }}</p>

        <base-image src="/static/images/lanterns/lantern_sign.svg" image-class="middle_img" alt="lantern icon" />

        <p>{{ getTranslations.modal_post_game_lantern_success_you_earned }}</p>

        <div class="gift_points_box">
          <div class="header">{{ getTranslations.modal_post_game_lantern_success_reward }}</div>

          <div class="flex-row">
            <p class="points">+{{ prizeValue }}</p>

            <base-image src="/static/images/home/points_star.png" />
          </div>
        </div>
      </template>

      <template v-else>
        <h1>{{ getTranslations.modal_post_game_lantern_failed_title }}</h1>

        <p>{{ getTranslations.modal_post_game_lantern_failed_subtitle }}</p>

        <base-image src="/static/images/lanterns/lantern_sign.svg" image-class="middle_img" alt="lantern icon" />

        <p>
          {{ getTranslations.modal_post_game_lantern_failed_description_pt1 }}<br>
          {{ getTranslations.modal_post_game_lantern_failed_description_pt2 }}
        </p>
      </template>

      <base-button
        container-class="get_points"
        button-class="fancy_btn close_modal"
      >
        {{ getTranslations.modal_post_game_lantern_button_proceed }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseModal from '../../../../common/modal/BaseModal.vue';
import BaseImage from '../../../../common/image/BaseImage.vue';
import BaseButton from '../../../../common/button/BaseButton.vue';

export default {
  name: 'PostGameLanternModal',
  components: {
    BaseModal,
    BaseImage,
    BaseButton,
  },
  props: {
    score: {
      type: Number,
      default: 0,
    },
    prizeValue: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    successful () {
      return this.score > 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addOnGame/components/PostGameLanternModal.vue